import React from 'react'

export const EditContext = React.createContext(null)

const EditProvider = ({ children }) => {
  // keep track of components that need to be edited
  const [editedMeta, setEditedMeta] = React.useState(false)
  const [editedAuth, setEditedAuth] = React.useState(false)
  const [editedImg, setEditedImg] = React.useState(false)
  const [forceSave, setForceSave] = React.useState(false)

  return (
    <EditContext.Provider
      value={{
        editedMeta,
        setEditedMeta,
        editedAuth,
        setEditedAuth,
        editedImg,
        setEditedImg,
        forceSave,
        setForceSave
      }}
    >
      {children}
    </EditContext.Provider>
  )
}

export default EditProvider

export function useEditContext () {
  return React.useContext(EditContext)
}
